import { State } from "history";
import instance, { functionBasedInstance } from "../../utils/apiCalls";
import { Action, ThunkDispatch } from "@reduxjs/toolkit";
import SUBSCRIPTION_URLS from "./subscriptionURL";

export const GetAllSubscriptions =
  (plan_for: "Builder" | "Agent", plan_type?: number) =>
  async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      let url = SUBSCRIPTION_URLS.getAllSubscriptionPlans;
      const params: Record<string, any> = { plan_for };
      if (plan_type) {
        params.plan_type = plan_type;
      }
      const response = await instance.get(url, { params });
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const getAllSubscriptionServices =
  (plan_for?: string) =>
  async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      let url = SUBSCRIPTION_URLS.getAllSubscriptionServices;
      const params: Record<string, string> = {};
      if (plan_for) {
        params.plan_type = plan_for;
      }
      const response = await instance.get(url, { params });
      return response;
    } catch (err: any) {
      throw err;
    }
  };
export const userSubscriptionsInsert =
  (data?: any) => async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.post(
        SUBSCRIPTION_URLS.usersubscriptionsinsert,
        data,
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const user_subscriptions_get_all =
  (data?: any) => async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.post(
        SUBSCRIPTION_URLS.user_subscriptions_get_all,
        data,
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const user_subscriptions_get_all_count =
  (data?: any) => async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.post(
        SUBSCRIPTION_URLS.user_subscriptions_get_all_count,
        data,
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const user_subscriptions_get_by_user_subscription_id =
  (data?: any) => async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.post(
        SUBSCRIPTION_URLS.user_subscriptions_get_by_user_subscription_id,
        data,
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const subscription_service_config_insert =
  (data?: any) => async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.post(
        SUBSCRIPTION_URLS.subscription_service_config_insert,
        data,
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const get_all_users =
  (data?: any) => async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.post(
        SUBSCRIPTION_URLS.get_all_users,
        data,
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const get_subscription_service_by_user_subscription_id =
  (data?: any) => async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.post(
        SUBSCRIPTION_URLS.get_subscription_service_by_user_subscription_id,
        data,
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const get_all_developer_for_subscription =
  (data?: any) => async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.get(
        SUBSCRIPTION_URLS.get_all_developer_for_subscription,
        { params: data },
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const get_user_analytic_by_user_id =
  (params?: any) =>
  async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await functionBasedInstance.get(
        SUBSCRIPTION_URLS.get_user_analytic_by_user_id,
        { params },
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const get_user_analytic_property_details =
  (params?: any) =>
  async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await functionBasedInstance.get(
        SUBSCRIPTION_URLS.get_user_analytic_property_details,
        { params },
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const get_user_analytic_ai_video_details =
  (params?: any) =>
  async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await functionBasedInstance.get(
        SUBSCRIPTION_URLS.get_user_analytic_ai_video_details,
        { params },
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const get_user_analytic_property_inquiry =
  (params?: any) =>
  async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await functionBasedInstance.get(
        SUBSCRIPTION_URLS.get_user_analytic_property_inquiry,
        { params },
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const get_user_analytic_project_inquiry =
  (params?: any) =>
  async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await functionBasedInstance.get(
        SUBSCRIPTION_URLS.get_user_analytic_project_inquiry,
        { params },
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const get_user_analytic_bank_property_inquiry =
  (params?: any) =>
  async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await functionBasedInstance.get(
        SUBSCRIPTION_URLS.get_user_analytic_bank_property_inquiry,
        { params },
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const get_user_analytic_lead_details =
  (params?: any) =>
  async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await functionBasedInstance.get(
        SUBSCRIPTION_URLS.get_user_analytic_lead_details,
        { params },
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const get_user_analytic_addressbox_lead_details =
  (params?: any) =>
  async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await functionBasedInstance.get(
        SUBSCRIPTION_URLS.get_user_analytic_addressbox_lead_details,
        { params },
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const get_user_analytic_ai_call_details =
  (params?: any) =>
  async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await functionBasedInstance.get(
        SUBSCRIPTION_URLS.get_user_analytic_ai_call_details,
        { params },
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const get_user_analytic_recent_activities =
  (params?: any) =>
  async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await functionBasedInstance.get(
        SUBSCRIPTION_URLS.get_user_analytic_user_activity_details,
        { params },
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const get_all_user_analytic_inquiry_type =
  (params?: any) =>
  async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await functionBasedInstance.get(
        SUBSCRIPTION_URLS.get_all_user_analytic_inquiry_type,
        { params },
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const get_all_developer_subscriptions =
  (params?: any) =>
  async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.get(
        SUBSCRIPTION_URLS.get_all_developer_subscriptions,
        { params },
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const get_developer_subscription_detail =
  (developer_subscription_id: string | number) =>
  async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.get(
        `${SUBSCRIPTION_URLS.get_developer_subscription_detail}/${developer_subscription_id}`,
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const insert_developer_team_members =
  (data?: any) => async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.post(
        SUBSCRIPTION_URLS.insert_developer_team_members,
        data,
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const get_all_project_by_developer_id =
  (data?: any) => async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.get(
        SUBSCRIPTION_URLS.get_all_project_by_developer_id,
        { params: data },
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const main_developer_subscription =
  (data?: any) => async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.post(
        SUBSCRIPTION_URLS.main_developer_subscription,
        data,
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const project_team_member_delete =
  (developer_subscription_id: string | number, data: any) =>
  async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.delete(
        `${SUBSCRIPTION_URLS.project_team_member_delete}/${developer_subscription_id}`,
        { data },
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const developer_subscription_project_delete =
  (developer_subscription_id: string | number, data: any) =>
  async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.delete(
        `${SUBSCRIPTION_URLS.developer_subscription_project_delete}/${developer_subscription_id}`,
        { data },
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };
export const owner_subscriptions_get_all =
  (data?: any) => async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.post(
        SUBSCRIPTION_URLS.owner_subscriptions_get_all,
 data,
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };
export const cpAgentSubscriptionInsert =
  (data?: any) => async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.post(
        SUBSCRIPTION_URLS.cpAgentSubscriptionInsert,
        data,
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };

export const owner_subscriptions_get_all_count =
  (data?: any) => async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.post(
        SUBSCRIPTION_URLS.owner_subscriptions_get_all_count,
               data,
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };
export const cpAgentProjectTeamMemberDelete =
  (data?: any) => async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.post(
        SUBSCRIPTION_URLS.cpAgentProjectTeamMemberDelete,
        data,
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };
  

export const cpAgentSubscriptionProjectDelete =
  (data?: any) => async (dispatch: ThunkDispatch<State, undefined, Action>) => {
    try {
      const response = await instance.post(
        SUBSCRIPTION_URLS.cpAgentSubscriptionProjectDelete,
        data,
      );
      return response;
    } catch (err: any) {
      throw err;
    }
  };
